// src/pages/AuthPage/index.jsx

import React, { useEffect, useState } from 'react';
import { Amplify } from 'aws-amplify';
import { fetchAuthSession } from 'aws-amplify/auth';
import { Authenticator } from '@aws-amplify/ui-react';
import awsExports from '../../aws-exports';  // Adjust relative path accordingly
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';

Amplify.configure(awsExports);

export default function AuthPage() {
  const [tokens, setTokens] = useState(null);

  return (
    <>
      <Header />
      <Authenticator>
        {({ user, signOut }) => {
          // React hook called unconditionally, always in same order
          useEffect(() => {
            async function fetchTokens() {
              if (!user) return; // Exit early if not authenticated
              try {
                const session = await fetchAuthSession();
                setTokens({
                  idToken: session.tokens.idToken.jwtToken,
                  accessToken: session.tokens.accessToken.jwtToken,
                  refreshToken: session.tokens.refreshToken?.token,
                });
                console.log('Tokens fetched successfully:', session.tokens);
              } catch (error) {
                console.error('Error fetching auth session tokens:', error);
              }
            }
            fetchTokens();
          }, [user]); // Re-run when user changes

          if (!user) {
            return <p style={{ textAlign: 'center' }}>Please sign in to access the app.</p>;
          }

          return (
            <main style={{ padding: '2rem', textAlign: 'center' }}>
              <h1>Hello, {user.username}</h1>
              {tokens ? (
                <>
                  <h2>Your ID Token:</h2>
                  <textarea
                    readOnly
                    style={{ width: '100%', height: 150 }}
                    value={tokens.idToken}
                    aria-label="ID Token"
                  />
                  <h2>Your Access Token:</h2>
                  <textarea
                    readOnly
                    style={{ width: '100%', height: 150 }}
                    value={tokens.accessToken}
                    aria-label="Access Token"
                  />
                </>
              ) : (
                <p>Loading tokens...</p>
              )}
              <button onClick={signOut} style={{ marginTop: '1rem' }}>
                Sign Out
              </button>
            </main>
          );
        }}
      </Authenticator>
      <Footer />
    </>
  );
}
